module.exports = __webpack_public_path__ + "media/images/partner/schwingstetter-a828fc3ef16ede24555cbfc57269238d.jpg";